(function() {
    'use strict';

    angular.module('dashboardApp').service('State', Service);

    Service.$inject = [
    ];


    function Service(
    ) {

        var service = this;




    }

})();
